module.exports = __webpack_public_path__ + "static/media/copy.b34f4289.svg";